import Commons from '../shared/libraries/commons';
import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class AddSerializer extends BaseSerializer {
  deserialize(raw) {
    const serverRes = raw.data || raw.error;
    console.log('🚀 ~ AddSerializer ~ deserialize ~ serverRes:', serverRes);
    const success =
      serverRes.statusCode == 200 ||
      serverRes.statusCode == 201 ||
      serverRes.statusCode == 404;
    if (!success) {
      return {
        statusCode: serverRes.statusCode || raw.status || 500,
        success: false,
        message:
          (serverRes.message || 'Erreur lors de la récupération') +
          ` Code d'erreur: ADS_ERR_${
            serverRes.statusCode || raw.status || '1000'
          }`,
        data: null
      };
    }
    return {
      statuCode: 200,
      success: true,
      message: 'Ads got',
      data: (Array.isArray(serverRes?.data?.appInfo?.ads)
        ? serverRes?.data?.appInfo?.ads
        : []
      ).map((ad) => {
        return {
          id: ad.id,
          title: ad.title,
          description: ad.description,
          pictureUrl: ad.pictureUrl,
          targetUrl:
            ad.targetUrl && ad.targetUrl.startsWith('http') ? ad.targetUrl : ''
        };
      })
    };
  }

  serialize(newAd, allAds) {
    let res = [...allAds];
    let updated = false;
    res.forEach((el, i) => {
      if (!el.id) {
        res[i].id = Commons.generateUUID();
        return;
      }
      if (el.id !== newAd.id) return;
      updated = true;
      res[i] = newAd;
    });
    if (!updated) {
      res.push({
        ...newAd,
        id: newAd.id || Commons.generateUUID()
      });
    }
    res = res.filter((el) => el.action !== 'delete');
    return {
      appInfo: {
        ads: res
      }
    };
  }
}

export const serializer = new AddSerializer();
